import script from "./Sale-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Sale-item.vue?vue&type=script&setup=true&lang=js"

import "./Sale-item.vue?vue&type=style&index=0&id=2a102978&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a102978"]])

export default __exports__